import React from 'react'
import CulturalHeritageRoutes from './culturalHeritageRoutes'
import KMCRoutes from './kmcRoutes'
import { useLocation } from 'react-router-dom';
import MsedclRoutes from './msedclRoutes';
import MerchantPageRoutes from './merchantPageRoutes';
import MPCZRoutes from './mpczRoutes';


const MainRoutes = () => {
  const location = useLocation();
  const path = location?.pathname;
  return (
    <>
    {path?.includes('/cultural-heritage/') && <CulturalHeritageRoutes />}
    {path?.includes('/pay-property-tax/') && <KMCRoutes />}
    {path?.includes('/kmc-pay-property-assessment-extract/') && <KMCRoutes />}
    {path?.includes('/pay-property-noc-certificate/') && <KMCRoutes />}
    {path?.includes('/water-tax-payment/') && <KMCRoutes />}
    {path?.includes('/msedcl/') && <MsedclRoutes />}
     {path?.includes('/license-fee-payment/') && <KMCRoutes />}
     {path?.includes('/general-demand-service/') && <KMCRoutes />}
    {path?.includes('/track-grievance-status/') && <KMCRoutes />}
    {path?.includes('/lodge-grievance/') && <KMCRoutes />}
    {path?.includes('/txn-status/') && <MerchantPageRoutes />}
    {path?.includes('/mpcz/') && <MPCZRoutes />}
    </>
  )
}

export default MainRoutes
